import React from 'react';
import Button from 'components/element/Button';
import Twut from './Twut';

export const useThreadMap = (thread, expandedReplies) => {
    const [threadMap, setThreadMap] = React.useState({});

    React.useEffect(() => {
        if (thread && thread.replies) {
            const newMap = {};

            const mapReplies = (replies, parentId, depth = 0) => {
                replies.forEach(reply => {
                    newMap[reply.id] = { parentId, depth };
                    if (expandedReplies[reply.id] && expandedReplies[reply.id].replies) {
                        mapReplies(expandedReplies[reply.id].replies, reply.id, depth + 1);
                    }
                });
            };

            mapReplies(thread.replies, thread.id);
            setThreadMap(newMap);
        }
    }, [thread, expandedReplies]);

    const getReplyDepth = (replyId) => {
        return threadMap[replyId]?.depth || 0;
    };

    return { threadMap, getReplyDepth };
};

export const NestedReply = ({
    replies,
    depth = 0,
    expandedReplies,
    handleExpandReplies,
    handleViewThread,
    handleUpdateSubmission,
    handleDeleteTwut,
    handleReplySubmission,
    isProcessing,
    getReplyDepth
}) => {
    if (!replies || replies.length === 0) return null;

    return (
        <div className="thread-container">
            {replies.map((reply, index) => {
                const replyDepth = getReplyDepth(reply.id);
                const isMaxDepth = replyDepth >= 2;
                const isNested = depth > 0;

                return (
                    <div key={reply.id} className="mb-3">
                        <div className={`reply-container rounded-lg pl-0.5 ${!isNested ? "pb-0.5" : "pb-0"}`}>
                            <Twut
                                twut={reply}
                                onUpdate={handleUpdateSubmission}
                                onDelete={handleDeleteTwut}
                                onReply={handleReplySubmission}
                                isUpdating={isProcessing}
                            />

                            {reply.has_replies && (
                                <div className="mb-2 border-l-2 border-gray-less">
                                    <Button
                                        onClick={() => isMaxDepth ? handleViewThread(reply.id) : handleExpandReplies(reply.id)}
                                        className="!justify-start text-gray-strong hover:text-gray-strongest w-full py-1 text-sm transition-all duration-200"
                                    >
                                        <i className={`fa-solid ${isMaxDepth ? "fa-arrow-right" : expandedReplies[reply.id] ? "fa-chevron-up" : "fa-chevron-down"} mr-1`}></i>
                                        {isMaxDepth
                                            ? `View thread (${reply.replies_count} replies)`
                                            : expandedReplies[reply.id]
                                                ? "Collapse replies"
                                                : `Expand replies`}
                                    </Button>

                                    {!isMaxDepth && expandedReplies[reply.id] && (
                                        <div className="replies-container ml-1">
                                            <NestedReply
                                                replies={expandedReplies[reply.id].replies}
                                                depth={depth + 1}
                                                expandedReplies={expandedReplies}
                                                handleExpandReplies={handleExpandReplies}
                                                handleViewThread={handleViewThread}
                                                handleUpdateSubmission={handleUpdateSubmission}
                                                handleDeleteTwut={handleDeleteTwut}
                                                handleReplySubmission={handleReplySubmission}
                                                isProcessing={isProcessing}
                                                getReplyDepth={getReplyDepth}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export const renderReplies = (replies, props) => <NestedReply replies={replies} {...props} />;
